import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import { PopupBox } from '../../Popup/styles'
import { Text } from '../ToolTip/styles'

export const PopupContainer = styled(PopupBox)`
  background-color: ${(props) => props.theme.lavender};
  padding: 56px 40px;
  b {
    font-family: 'MatterBold';
  }
  @media (max-width: ${breakpoints.m}px) {
    padding: 24px;
  }
  @media (max-width: ${breakpoints.s}px) {
    padding: 24px 16px 16px;
  }
  @media (max-width: 400px) {
    padding: 24px 8px 16px;
  }
`
export const Heading = styled.h2`
  font-family: 'MatterRegular';
  font-size: 28px;
  line-height: 120%;
  margin: 0px;
  color: #000;
  text-align: center;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 20px;
    width: 100%;
  }
`
export const SubHeading = styled.h3`
  font-family: 'MatterRegular';
  line-height: 140%;
  color: #000;
  margin-bottom: 32px;
  text-align: center;
  width: 420px;
  margin: 0px auto 32px;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 15px;
    margin: 8px 0px 16px;
    width: 100%;
  }
`
export const Disclosure = styled(Text)`
  font-size: 14px;
  text-align: center;
  @media (max-width: ${breakpoints.s}px) {
    margin-top: 16px;
    font-size: 9px;
  }
`
export const LogoWrapper = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-height: 100%;
    width: auto;
    object-fit: contain;
  }
`
export const Card = styled.div`
  background-color: ${(props) => props.theme.darkLavendar};
  border-radius: 10px;
  padding: 20px 16px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 280px;
  height: 100%;
  justify-content: space-around;
  span {
    margin-top: 4px;
  }
  span ::after {
    content: ' →';
    font-size: 1.2rem;
    text-decoration: underline;
  }
  @media (max-width: 800px) {
    width: 240px;
    #selfridges,
    #harveyNorman {
      width: 160px;
      object-fit: contain !important;
      margin: auto;
    }
  }
  @media (max-width: 650px) {
    span {
      font-size: 14px;
    }
    width: 200px;
  }
  @media (max-width: ${breakpoints.s}px) {
    border-radius: 10px;
    padding: 16px 24px 16px;
    width: 160px;
    span {
      display: none;
    }
    #amazon,
    #jbhifi {
      width: 100px;
      object-fit: contain !important;
      margin: auto;
    }
    #target {
      width: 40px;
      object-fit: contain !important;
      margin: auto;
    }
    #bestBuy {
      width: 70px;
      object-fit: contain !important;
      margin: auto;
    }
    #sams {
      width: 120px;
      object-fit: contain !important;
      margin: auto;
    }
    #costco {
      width: 90px;
      object-fit: contain !important;
      margin: auto;
    }
    #bjs {
      width: 50px;
      object-fit: contain !important;
      margin: auto;
    }
    #walmart,
    #currys,
    #selfridges,
    #harveyNorman {
      width: 110px;
      object-fit: contain !important;
      margin: auto;
    }
  }
  @media (max-width: 430px) {
    width: 130px;
  }
`
export const RetailerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  align-items: stretch;
  @media (max-width: ${breakpoints.s}px) {
    gap: 8px;
  }
`
export const Link = styled.a`
  color: white;
  margin-bottom: 0px !important;
`
